<template>
  <TopNav></TopNav>
  <h1>Kuvvet Hesaplama</h1>
  <fieldset>
    <legend>Kuvvet Hesaplama Aracı</legend>
    <label for="a">Kütle: </label> <input type="number" v-model.number="mass" id="a" step="any"> ㎏
    <br>
    <label for="b">İvme: </label> <input type="number" v-model.number="acceleration" id="b" step="any"> m/s<sup>2</sup>
    <br><br>
    Kuvvet = <span class="blue">{{ force() }} N</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Kuvvet",
  data() {
    return {
      mass: 100,
      acceleration: 10,
    }
  },
  components: {
    TopNav
  },
  methods: {
    force: function () {
      const kuvvet = this.mass * this.acceleration;
      const kuvvetNumber = Number(kuvvet);
      const formatter = new Intl.NumberFormat('tr-TR');

      return formatter.format(kuvvetNumber);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 70px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
